import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { FlexLayoutModule } from "@angular/flex-layout";
import { TranslateModule } from "@ngx-translate/core";

import { MatTabsModule } from "@angular/material/tabs";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatChipsModule } from "@angular/material/chips";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";

import { HomeComponent } from "./home.component";
import { DashboardModule } from "../shared/modules/dashboard/dashboard.module";
import { DatePickerModule } from "../shared/modules/datepicker-range/datepicker-range.module";
import { TabDatepickerModule } from "../shared/modules/tab-datepicker/tab-datepicker.module";
import { FleetDashboardComponent } from "./fleet-dashboard/fleet-dashboard.component";
import { RetailDashboardComponent } from "./retail-dashboard/retail-dashboard.component";
import { BusinessSelectModule } from "../shared/modules/business-select/business-select.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    FlexLayoutModule,
    MatTabsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatProgressBarModule,
    MatMenuModule,
    MatTooltipModule,
    DashboardModule,
    TabDatepickerModule,
    DatePickerModule,
    BusinessSelectModule,
],
  declarations: [
    HomeComponent,
    FleetDashboardComponent,
    RetailDashboardComponent,
  ],
})
export class HomeModule {}
